import { Toggle } from '..';

import cn from 'classnames';
import { Collapse } from 'react-bootstrap';

import { IconComponent } from 'components/Icon/IconComponent';
import StatusPill from 'components/Pills/StatusPills';

import styles from './ToggleSwitchInput.module.scss';

export const ToggleSwitchInput = ({
  text,
  subtext,
  name,
  value,
  className,
  children,
  headerChildren,
  cardClassName,
  icon,
  noMaxWidth = false,
  dataTestId,
  toggle = true,
  status,
  statusText,
  onChange = () => {},
}) => {
  return (
    <div
      className={cn(styles.root, 'card', 'card-with-border', 'u-width-100', 'u-margin-bottom', {
        [className]: className,
        [styles.noMaxWidth]: noMaxWidth,
      })}>
      <div
        className={cn('card_content', 'u-width-100', 'u-border-radius', {
          [cardClassName]: cardClassName,
        })}>
        <div className="d-flex flex-column u-width-100">
          <div
            className={cn(
              styles.input,
              'u-width-100',
              'd-flex',
              'align-items-center',
              'justify-content-between',
            )}>
            <div className={cn('d-flex', 'align-items-center', 'u-width-75')}>
              {icon && <IconComponent icon={icon} className="u-margin-right" />}
              <div className="d-flex flex-column">
                <span className="u-font-size-small u-font-weight-500 primary-text">{text}</span>
                <span className="u-font-size-x-small secondary-text">{subtext}</span>
              </div>
            </div>
            {toggle && (
              <Toggle inputProps={{ name, checked: value, onChange }} dataTestId={dataTestId} />
            )}
            {status && !toggle && <StatusPill text={statusText} status={status} />}
          </div>
          {headerChildren && (
            <>
              <div className="u-divider" />
              <div className="u-margin-left--small">{headerChildren}</div>
            </>
          )}
        </div>
        <Collapse in={children && value} className="u-width-100">
          <div>
            <div className={cn(styles.content)}>{children}</div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};
